import { PDFData } from '@types'

interface EditPDFModalCoordinator {
  UIService: {
    EditPDFModal: {
      show: () => void
      close: () => void
    }
  }
  EditPDFService: {
    setPDFData: (pdfData: PDFData) => void
    clearPDFData: () => void
  }
}
export const ShowEditPDFModal =
  ({ UIService, EditPDFService }: EditPDFModalCoordinator) =>
  (data: PDFData) => {
    EditPDFService.setPDFData(data)
    UIService.EditPDFModal.show()
  }
export const CloseEditPDFModal =
  ({ UIService, EditPDFService }: EditPDFModalCoordinator) =>
  () => {
    EditPDFService.clearPDFData()
    UIService.EditPDFModal.close()
  }
